import { getT, useI18nStore } from '@/i18n';
import { f7, f7ready } from 'framework7-react';

let installed = false;

export function installDialogLocale(): void {
  if (installed) return;
  installed = true;
  f7ready(() => {
    const updateLabels = () => {
      const t = getT();
      f7.params.dialog = { ...f7.params.dialog, buttonOk: t.ok, buttonCancel: t.cancel };
    };

    updateLabels();
    useI18nStore.subscribe((state, previousState) => {
      if (state.locale !== previousState.locale) updateLabels();
    });
  });
}
